var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value === 1)?_c('a-tag',{staticClass:"success-text",attrs:{"color":"#27C34633"}},[_vm._v(" 已完成 ")]):(_vm.value === 0)?_c('a-tag',{staticClass:"unfinished-text",attrs:{"color":"#F7696533"}},[_vm._v(" 未完成 ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }